import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className", "clsPrefix"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import { WebUI } from "../../wui-core/src/index.js";
var defaultProps = {
  clsPrefix: 'u-input-group-btn'
};
var InputGroupButton = (_dec = WebUI({
  name: "input-group-btn",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(InputGroupButton, _React$Component);

  var _super = _createSuper(InputGroupButton);

  function InputGroupButton() {
    _classCallCheck(this, InputGroupButton);

    return _super.apply(this, arguments);
  }

  _createClass(InputGroupButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          clsPrefix = _this$props.clsPrefix,
          others = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("span", _extends({}, others, {
        className: classNames(className, clsPrefix)
      }));
    }
  }]);

  return InputGroupButton;
}(React.Component)) || _class);
export default InputGroupButton;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input/src/InputGroupButton.js